import React from 'react'

const debug = false
// const debug = "FieldColor_PickerValueEmpty"

export default function FieldColor_PickerValueEmpty(props:any) {

    debug && console.log(debug, 'render', props)

    const classes       = Classes("ui5-field-picker is-empty", "size-"+props.size, props.className)
    const colorClasses  = Classes("ui5-color-picker empty", {
        's-30': props.size === '30'
    })

    return (
        <div className={classes} onClick={props.onClick}>
            {props.field.showEmptyColorPicker &&
                <div className={colorClasses}/>}

            {!props.field.showEmptyColorPicker &&
                <div className={Classes("icon", props.field.icon)}/>}

            {props.children}
        </div>
    )
}
